module.exports = __webpack_public_path__ + "static/media/del.e7d366e8.svg";